/**
 * File: purchaseList.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class PurchaseListController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        $scope.productList = [];
        $scope.showUpdateButton = false
        $scope.showEditConsole = []
        $scope.pageSize = 50;
        $scope.totalCount = 0;
        $scope.medicineCount = 0
        $scope.errors = {}
        $scope.gotoPurchaseorder = () => {
            $state.go('purchaseOrder')
        }
        $scope.editProduct = (index, productId, product) => {
                $scope.showEditConsole[index] = true
                $scope.showUpdateButton = true
            }
            //To update delivery status of medicine
        $scope.updatePurchaseStatus = (product) => {
            authService.callAPI(MEDICALCONSTANT.API_UPDATE_PURCHASE_ORDER, "POST", product, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Updated Successfully")
                    $scope.showEditConsole = []
                    $scope.productList = new purchaseItems();
                }
            })
        }

        /*********** Prototype for pagination: START ******************/
        function purchaseItems() {
            this.loadedPages = {}; //details of loaded pages on scroll
            this.numItems = 0; //total number of items
            this.PAGE_SIZE = $scope.pageSize; //number of items per page
            this.fetchPage_(0);
        };

        //To get the item at the index
        //index -> current index
        purchaseItems.prototype.getItemAtIndex = function(index) {
            //calculate the page number of the given index
            let pageNumber = Math.floor(index / this.PAGE_SIZE);
            let page = this.loadedPages[pageNumber];
            //if page items are loaded
            if (page) {
                return page[index % this.PAGE_SIZE];
            } else if (page !== null) {
                //else fetch the page content. calling method to fetch item from db
                this.fetchPage_(pageNumber);
            }
        };

        //To get the total number of items
        purchaseItems.prototype.getLength = function() {
            return this.numItems;
        };

        //To fetch the items from db
        //pageNumber -> number for which page the items to be fetched
        purchaseItems.prototype.fetchPage_ = function(pageNumber) {
            this.loadedPages[pageNumber] = null;
            //To calculate the page offset(number of items to be skiped)
            let pageOffset = pageNumber * this.PAGE_SIZE;
            let paginationOpts = {
                limit: parseInt(this.PAGE_SIZE),
                skip: parseInt(pageOffset),
            };
            let obj = {
                pagination_options: paginationOpts,
                school_id: schoolId
            }
            authService.callAPI(MEDICALCONSTANT.API_GET_PURCHASE_ORDER, "POST", obj, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    this.numItems = response.result.data.data.count
                    this.totalCount = response.result.data.data.count
                    $scope.medicineCount = response.result.data.data.count
                    this.loadedPages[pageNumber] = response.result.data.data.list
                    $scope.productDetails = response.result.data.data.list
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        };
        $scope.productList = new purchaseItems();
    }
}
export default PurchaseListController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/inventory/purchaseList.js